$.ready(function() {
	var anticipation = game.anticipation = $.div('anticipation');
	
	anticipation.show = function(reel) {
		reel = game.spindle.reels[reel];
		
		for (var i = 0; i < game.spindle.reels.length; i++) {
			game.spindle.reels[i].removeClass('anticipate');
		}
		
		game.spindle.addClass('anticipate');
		reel.addClass('anticipate');
	};
	
	anticipation.hide = function(reel) {
		reel = game.spindle.reels[reel];
		
		game.spindle.removeClass('anticipate');
		
		setTimeout(function() {
			reel.removeClass('anticipate');
		}, 250);
	};
});



/** WEBPACK FOOTER **
 ** /Users/kevinduarte/SG/roc2/plugins/slot/public-src/common/js/container-anticipation.js
 **/